import { z } from 'zod'

import { RECALL_SALES_CHANNEL_OPTIONS } from '#app/routes/mocra+/_form+/intake-options.ts'

export const SalesChannelEntrySchema = z.object({
	type: z.enum(
		RECALL_SALES_CHANNEL_OPTIONS.map((option) => option.value) as [
			(typeof RECALL_SALES_CHANNEL_OPTIONS)[number]['value'],
			...string[],
		],
	),
	name: z
		.string({
			required_error: 'Name the channel or partner.',
		})
		.min(1, 'Name the channel or partner.'),
})

export type SalesChannelEntry = z.infer<typeof SalesChannelEntrySchema>
